import { Directive, ViewContainerRef } from "@angular/core";

@Directive({
  selector: '[adPopupDirective]',
  standalone: false
})
export class SysquePopupAdDirective{
    constructor(public viewContainerRef: ViewContainerRef){}
}